import classNames from "classnames"

import { useTranslation } from "@/locales"

import styles from "./index.module.less"

interface Props {
    index: number
    onClick?: () => void
    className?: string
    style?: React.CSSProperties
}

const Cover: React.FC<Props> = (props) => {
    const { index, onClick, className, style } = props

    const { t } = useTranslation()

    return (
        <div className={classNames(styles.cover, className)} style={style}>
            <div className={styles.inner}>
                <div className={styles.original}>
                    <div className={styles.blur} />
                </div>
            </div>
            <div className={styles.title}>
                <div className={styles.play} onClick={onClick} />
                <div className={styles.main}>
                    <div className={styles.bg} />
                    <div className={styles.text}>{t(`pv.${index}.title`)}</div>
                </div>
                <div className={styles.sub}>
                    <div>{t(`pv.${index}.title.sub`)}</div>
                </div>
            </div>
        </div>
    )
}

export default Cover
